import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {FieldsModule} from '../../components/fields/fields.module';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {AngularMultiSelectModule} from '../../components/angular2-multiselect-dropdown/multiselect.component';
import {SafeHtmlPipeModule} from '../../pipes/safe-html/safe-html-pipe.module';
import {SettingsDirectoryService} from '../../services/settings-directory.service';
import {SettingsDirectoryComponent} from './settings-directory.component';
import {SettingsDirectoryDetailedViewComponent} from './settings-directory-detailed-view/settings-directory-detailed-view.component';
import {CorporationsListComponent} from './corporations-list/corporations-list.component';
import {DirectoryRemindersModalComponent} from './directory-reminders-modal/directory-reminders-modal.component';
import {NotificationModalComponent} from './notification-modal/notification-modal.component';
import {UtilsModule} from '../../modules/utils/utils.module';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule,
        AngularMaterialImportModule,
        AngularMultiSelectModule,
        SafeHtmlPipeModule,
        UtilsModule
    ],
    declarations: [
        SettingsDirectoryComponent,
        SettingsDirectoryDetailedViewComponent,
        CorporationsListComponent,
        DirectoryRemindersModalComponent,
        NotificationModalComponent
    ],
    providers: [
        SettingsDirectoryService
    ]
})
export class SettingsDirectoryModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/settings-directory/settings-directory.module.ts